module.exports = __webpack_public_path__ + "static/media/Avatars_Male-26.47547338.png";